import React from 'react';
import { connect } from 'react-redux';

import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import { getParams, downloadCSV } from 'actions/stats';
import { chainGetPNG, dumpAllToPDF } from "./functions"

class StatsExport extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false
        };
    }

    downloadCSV() {
        this.setState({ loading: true }, () => {
            downloadCSV(this.props.node, this.props.querySettings, () => {
                this.setState({ loading: false })
            })
        })
    }

    downloadPDF() {
        this.setState({ loading: true }, () => {
            var images = [];
            chainGetPNG([
                document.charts.totalOccupancy,
                document.charts.occupancyrange,
                document.charts.occupancyBreakDown,
                document.charts.dailyOccupancy1,
                document.charts.dailyOccupancy2
            ], images,
                () => {
                    this.setState({ loading: false });
                    dumpAllToPDF(images, this.getPDFName());
                });
        });
    }

    getPDFName() {
        let settings = getParams({
            querySettings: this.props.querySettings,
            currentNode: this.props.node
        });
        let locationName = this.props.tree.info.name.replace(/[^A-Za-z0-9]/g, '');
        return `STATS_${locationName}_${settings.startdate}_${settings.enddate}_${settings.starthour}:00_${settings.endhour}:59.pdf`;
    }


    render() {
        return (
            <div className="stats-export__container">
                <Dropdown className={this.props.className} header={
                    <div className={"stats-export display--flex__flex--center " + (this.state.loading ? "loading" : "")}>
                        {
                            this.state.loading ?
                                <img src="src/assets/icons/loading.gif" />
                                :
                                <span className="font-icon icon-export" />
                        }
                        <span style={{ marginLeft: "8px", fontFamily: "GTWalsheimProBold" }}>Export</span>
                    </div>
                } toggleable={!this.state.loading} noArrow>
                    <DropdownItem>
                        <div onClick={() => this.downloadCSV()}>
                            CSV : Data of sensors
                        </div>
                    </DropdownItem>
                    <DropdownItem>
                        <div onClick={() => this.downloadPDF()}>
                            PDF : Pictures of charts
                        </div>
                    </DropdownItem>
                </Dropdown>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        tree: state.overviewReducer.customerOverview,
        nodeMap: state.overviewReducer.nodeMap,
        querySettings: state.querySettingsReducer,
        cards: state.defaultSettingsReducer.card
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatsExport);


// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/dataexportdropdown/statsexport.jsx